const format12hourTime = (d: Date, format?: 'H:MM:SS' | 'H:MM'): string => {
  const template = format || 'H:MM:SS';
  let hours = d.getHours();
  const suffix = hours >= 12 ? 'pm' : 'am';
  // only -12 from hours if it is greater than 12 (if not back at mid night)
  hours = hours > 12 ? hours - 12 : hours;
  // if 00 then it is 12 am
  hours = hours === 0 ? 12 : hours;

  let parsedTemplate = template as string;
  const h = `${hours}`;
  const mm = d.getMinutes().toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
  const ss = d.getSeconds().toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
  parsedTemplate = parsedTemplate.replace('H', h);
  parsedTemplate = parsedTemplate.replace('MM', mm);
  parsedTemplate = parsedTemplate.replace('SS', ss);
  return `${parsedTemplate}${suffix}`;
};

const randomDate = (start: Date, end: Date) => new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));

// This will return the traditional H:MM formatting if the timestamp is on the same day as the current device. Otherwise
// it will return MM/DD format.
const formatMonthDayOr12hourTime = (d: Date) => {
  const now = new Date();
  if (now.getFullYear() === d.getFullYear() && now.getMonth() === d.getMonth() && now.getDate() === d.getDate()) return format12hourTime(d, 'H:MM');
  const mm = d.getMonth() + 1;
  const dd = d.getDate();
  return `${mm}/${dd}`;
};

export { format12hourTime, formatMonthDayOr12hourTime, randomDate };
